import BetaLabel from '@anm/components/BetaLabel';
import { DropdownGroupProps } from '@anm/components/Dropdown';
import { VIDEO_TEMPLATE_ROUTE } from '@anm/constants/routes';
import isMobile from '@anm/helpers/is/isMobile';
import { memo, FC, useContext } from 'react';

import routes from '../../../routes';

import CategoryDropdown from './CategoryDropdown';
import { CategoryText, ItemWrapper } from './Wrapper';
import { ListItemProps } from './types';
import usePageParams from '@anm/hooks/usePageParams';
import { EMBED_INTERNAL_PARAM } from '@anm/constants/wave-editor';
import { BetaLabelsContext } from '@anm/contexts/BetaLabelsContext';

const { Link } = routes;

const ListItem: FC<ListItemProps & DropdownGroupProps> = ({ label, page, color, ...otherProps }) => {
  const { embed, isSemrush } = usePageParams();
  const {showLabels} = useContext(BetaLabelsContext)
  const isInternalEmbed = embed === EMBED_INTERNAL_PARAM;

  if (!isMobile()) {
    return <CategoryDropdown {...{ label, color, page, isInternalEmbed, ...otherProps }} />;
  }

  const canShowNewLabel = showLabels && label === 'image templates';

  return (
    <Link route={VIDEO_TEMPLATE_ROUTE} params={{ pageName: page, ...(isSemrush && { isSemrush })  }}>
      <a>
        <ItemWrapper {...{ color, isInternalEmbed }}>
          <CategoryText>{label}</CategoryText>
          {canShowNewLabel && <BetaLabel styleVariant="new-yellow" positionVariant="top-right" />}
        </ItemWrapper>
      </a>
    </Link>
  );
};

export default memo(ListItem);
